import { useEffect, useState } from "react"
import Table from "../Table"
import MyModal from "../MyModal"
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import Input from "../Input"
import { addRadio, deleteRadio, editRadio, getRadioList } from "../../services/radioApis"

const cols = [
    {
        name: "اسم رادیو",
        colSpan: 1,
    },
    {
        name: "لینک",
        colSpan: 1,
    },
    {
        name: "توضیحات",
        colSpan: 1,
    },

    {
        name: "",
        colSpan: 1,
    },
]

const EditRadioModal = ({ radio }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            radioId: radio.id,
            name: form.get("radio-name"),
            url: form.get("radio-url"),
            information: form.get("information") == "" ? null : form.get("information"),
        }
        toast
            .promise(editRadio(data), {
                pending: "درحال ویرایش",
                success: "ویرایش شد",
            })
            .catch((err) => {
                console.error(err)
            })
    }

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
            >
                <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
            </button>
            <MyModal width="400px" height="300px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input
                            label="نام رادیو"
                            type="text"
                            name="radio-name"
                            placeholder="نام"
                            required={true}
                            defaultValue={radio.name}
                        />
                    </div>
                    <div>
                        <Input
                            label="لینک"
                            type="text"
                            name="radio-url"
                            placeholder="Url"
                            required={true}
                            defaultValue={radio.url}
                        />
                    </div>

                    <div>
                        <Input
                            label="توضیحات"
                            name="information"
                            placeholder="توضیحات"
                            defaultValue={radio.information}
                            required={true}
                        />
                    </div>

                    <button type="submit" className="mt-5 w-full styled-button border">
                        ویرایش رادیو
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const AddRadioModal = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            name: form.get("radio-name"),
            url: form.get("radio-url"),
            information: form.get("information") == "" ? null : form.get("information"),
        }

        toast
            .promise(addRadio(data), {
                pending: "درحال اضافه کردن",
                success: "اضافه شد",
            })
            .catch((err) => {
                console.error(err)
            })
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-28 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                اضافه رادیو
            </button>
            <MyModal width="400px" height="300px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input label="نام رادیو" type="text" name="radio-name" placeholder="نام" required={true} />
                    </div>
                    <div>
                        <Input label="لینک" type="text" name="radio-url" placeholder="Url" required={true} />
                    </div>

                    <div>
                        <Input label="توضیحات" name="information" placeholder="توضیحات" />
                    </div>

                    <button type="submit" className="mt-5 w-full styled-button border">
                        اضافه رادیو
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const RadioList = ({ user }) => {
    const [radioList, setRadioList] = useState(null)
    const updateUi = () => {
        if (user) {
            getRadioList(user.token)
                .then(({ data }) => {
                    data = data.map((radio) => {
                        let obj = {
                            name: radio.name,
                            url: radio.url,
                            information: radio.information,
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <EditRadioModal user={user} radio={radio} />
                                    <button
                                        onClick={() => {
                                            toast.promise(deleteRadio(radio.id), {
                                                success: "حذف شد",
                                                pending: "درحال حذف",
                                            })
                                        }}
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setRadioList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <AddRadioModal user={user} />
            <Table cols={cols} rows={radioList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default RadioList
